export default "__VITE_ASSET__TvEjzqjU__"